module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09BGF8GLC.2ebb400b.jpg";